// src/components/RedirectHandler.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import usePedido from "../../hooks/usePedido";
import { getlocalStorageCarrinhoTemp } from "../../util/LocalStorage";

const RedirectHandler = () => {
  const { user } = useAuth();
  const { itensPedido, quantidadePedido, refetchPedido } = usePedido();
  const navigate = useNavigate();
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    const justLoggedIn = sessionStorage.getItem('justLoggedIn');
    
    if (justLoggedIn === 'true' && user && !redirected) {
      console.log("RedirectHandler - Usuário acabou de logar, ID:", user.id);
      
      // 1. Primeiro, verifica o carrinho temporário (pré-carrinho)
      const carrinhoTemp = getlocalStorageCarrinhoTemp();
      console.log("RedirectHandler - Carrinho Temp:", carrinhoTemp);
      
      const temCarrinhoTemp = carrinhoTemp && carrinhoTemp.itens && carrinhoTemp.itens.length > 0;
      
      if (temCarrinhoTemp) {
        console.log("✅ RedirectHandler - Carrinho temporário encontrado! Itens:", carrinhoTemp.itens.length);
        console.log("✅ RedirectHandler - Redirecionando para o carrinho!");
        sessionStorage.removeItem('justLoggedIn');
        setRedirected(true);
        navigate("/carrinho");
        return;
      }
      
      // 2. Se não tiver carrinho temporário, verifica o carrinho principal no backend
      console.log("RedirectHandler - Forçando busca do carrinho principal...");
      
      refetchPedido().then((result) => {
        console.log("RedirectHandler - Resultado da busca:", result.data);
        
        if (result.data && result.data.data) {
          const pedido = result.data.data;
          const temItens = pedido?.itens?.length > 0;
          console.log("RedirectHandler - Itens encontrados:", temItens);
          console.log("RedirectHandler - Quantidade:", pedido?.itens?.length);
          
          if (temItens) {
            console.log("✅ RedirectHandler - Carrinho principal encontrado! Redirecionando...");
            sessionStorage.removeItem('justLoggedIn');
            setRedirected(true);
            navigate("/carrinho");
          } else {
            console.log("❌ RedirectHandler - Carrinho vazio");
            sessionStorage.removeItem('justLoggedIn');
          }
        } else {
          console.log("❌ RedirectHandler - Nenhum dado retornado");
          sessionStorage.removeItem('justLoggedIn');
        }
      }).catch((error) => {
        console.error("RedirectHandler - Erro ao buscar carrinho:", error);
        sessionStorage.removeItem('justLoggedIn');
      });
    }
  }, [user, refetchPedido, navigate, redirected]);

  return null;
};

export default RedirectHandler;